import axios from "axios";

//const BASE_URL = "http://localhost:8080";
const BASE_URL = "https://gate.serrinha.rn.gov.br";

const api = axios.create({
    baseURL: `${BASE_URL}/api/v1`,
});

export const getNewsAPI = async (params) => await api.get("/news", { params });
export const getPortalSectionsAPI = async () => await api.get("/portal");
export const getMunicipalExecutiveAPI = async () => await api.get("/portal/municipal-executives");
export const getSecretariatsAPI = async () => await api.get("/portal/secretariats");
export const getFAQsAPI = async () => await api.get("/faqs");
